import { useCallback, useState } from 'react';
import { compose, flatten, map, prop, values } from 'rambda';

/**
 * Apply property changes for group and its children, that can be both as well groups
 * @param group
 * @param updateFn
 */
export const applyPropsChangeToGroup = (group: any, updateFn: (el: any) => void) => {
    // If not the root group, and is a child itself
    if (typeof group.parentId !== 'undefined') {
        updateFn(group);
    }

    Object.values(group.children).forEach((child: any) => {
        if (child.type !== 'GROUP') {
            updateFn(child);
        } else {
            applyPropsChangeToGroup(child, updateFn);
        }
    });
};

export const useToggleExpand = (defaultExpandedIds: any[]): [any[], (layerId: any) => void] => {
    const [expandedIds, setExpandedIds] = useState<any[]>(defaultExpandedIds);

    const handler = useCallback((layerId: any) => {
        setExpandedIds((expandedIds) => {
            if (expandedIds.includes(layerId)) {
                return expandedIds.filter((id) => id !== layerId);
            }

            return [...expandedIds, layerId];
        });
    }, []);

    return [expandedIds, handler];
};

export const getGroupChildren: any = compose(
    flatten,
    map((child: any) => (child.type === 'GROUP' ? getGroupChildren(child).concat(child) : child)),
    values,
    prop('children'),
);

export const getGroupChildrenIds = compose(
    map((el: any) => el.id),
    getGroupChildren,
);
